module.exports = __webpack_public_path__ + "img/04.7b2036d3.png";